import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import {errorlist} from '../providers/errorlist';
@Component({
  selector: 'app-place-holder',
  templateUrl: './place-holder.component.html',
  styleUrls: ['./place-holder.component.css']
})
export class PlaceHolderComponent implements OnInit {
  form: FormGroup;
  orderSecondChoice:boolean = false;
  save_card_id:boolean = true;
  chooseCardId:any = "";
  recurring:any = false;
  DAYS:any = [];
  TIME:any =[];
  errorlist : any;
  orderData:any;
  errormsg: string = "";
  service_errormsg: string = "";
  laundryOptions: any = [];
  orderLimitData:any = [];
  saveCardData:any = [];
  TIME_RANGE1 :any = [];
  TIME_RANGE2 :any = [];
  TIME_RANGE3 :any = [];
  TIME_RANGE4 :any = [];
  TIME_RANGE_ID_CONVERT = {};
  pay_type:any = "online";
  dc_require:any = false;
  is_laundry:any = true;
  rush_order: Boolean = false;
  card_number: any = [];

  constructor(private formBuilder: FormBuilder, private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.errorlist = errorlist;
    this.DAYS = environment.DAYS;
    this.TIME = environment.TIME_RANGE;
    this.TIME_RANGE1 = environment.TIME_RANGE_UPDATED1;
    this.TIME_RANGE2 = environment.TIME_RANGE_UPDATED;
    this.TIME_RANGE3 = environment.TIME_RANGE_UPDATED1;
    this.TIME_RANGE4 = environment.TIME_RANGE_UPDATED;
    this.TIME_RANGE_ID_CONVERT = environment.TIME_RANGE_ID_CONVERT;

    this.form = this.formBuilder.group({
      day1: ['', Validators.required],
      time1: [null, Validators.required],
      day2: ['', Validators.required],
      time2: [null, Validators.required],
      day3: [''],
      time3: [null],
      day4: [''],
      time4: [null],
      detergent:[null, Validators.required],
      softner:[null, Validators.required],
      whitener:[null, Validators.required],
      pay_type:['online'],
      message:[null],
      orderSecondChoice: [],
      expMonth: [null , Validators.required],
      expYear: [null, Validators.required],
      card_number: [null, Validators.required],
      card_type: [null, Validators.required],
      csv: [null, Validators.required],
      save_card_id: [null],
      recurring:[null],
      dc_require:[null],
      is_laundry:[null],
      rush_order:[null],
    }, {
      //validator: this.check_atleast_one // your validation method
    });

    this.spinnerService.show();
    let sid = localStorage.getItem('sid');
    let area = JSON.parse(localStorage.getItem('currentUser'));
    let data = {"sid":sid, "area_id":area.area_id}
    this.auth.laundering_options(data).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.laundryOptions = response.data;
        //this.spinnerService.hide();
        console.log("laundering_options", this.laundryOptions)
      }
    })
    .then(() =>{
      let sid = localStorage.getItem('sid');
      let area = JSON.parse(localStorage.getItem('currentUser'));
      console.log("area",area)
      let order = {"sid":sid, "area_id":area.area_id}
      this.auth.order_limit_data(order).then((user) => {
        console.log(user.json());
        let response = user.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.orderLimitData = response.data;
          console.log("orderLimitData", this.orderLimitData)
          //this.spinnerService.hide();
        }
      })
    })
    .then(() => {
      let sid = localStorage.getItem('sid');
      this.auth.card_info({"sid":sid}).then((user) => {
        let response = user.json();
        if(response.replyMsg == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          if(response.data.cardData != ""){
            this.saveCardData = response.data;
          }
          
          this.spinnerService.hide();
        }
      })
    }) 
    .catch((err) => {
      this.spinnerService.hide();
      console.log("viiviviiv",err);
      this.auth.open(environment.error)
    });
  }

  public noWhitespaceValidator(control: FormGroup) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    console.log("isValid",isValid)
    return isValid ? null : { 'whitespace': true }
  }

  public check_atleast_one(AC: AbstractControl) {
    let is_laundry = AC.get('is_laundry').value; // to get value in input tag
    let dc_require = AC.get('dc_require').value;
    //console.log("is_laundry = ",is_laundry);
    //console.log("dc_require = ",dc_require);
    if(is_laundry || dc_require) {
      //AC.get('is_laundry').setErrors( {noonecheck: null} )
      return null
    } else {
      AC.get('is_laundry').setErrors( {noonecheck: true} )
    }
  }
  

  secondChoice(value){
    console.log(value);
    if(value == true){
      this.form.patchValue({day3 : ''});
      this.form.patchValue({time3 : null});
      this.form.patchValue({day4 : ''});
      this.form.patchValue({time4 : null});
    }else{
      this.form.controls['day3'].markAsUntouched();
      this.form.patchValue({day3 : ''});
      this.form.controls['time3'].markAsUntouched();
      this.form.patchValue({time3 : null});
      this.form.controls['day4'].markAsUntouched();
      this.form.patchValue({day4 : ''});
      this.form.controls['time4'].markAsUntouched();
      this.form.patchValue({time4 : null});
    }
  }
  paymentStatus(value){
    console.log(value)
    if(value == "cash"){
      this.form.patchValue({save_card_id : ""}); 
      this.chooseCardId = "";
    }
  }

  recurringChecked(value){
    console.log("recurringChecked",value)
  }

  isAnyoneChecked(){
    let is_laundry = this.is_laundry;
    let dc_require = this.dc_require;
    //console.log("is_laundry = ",is_laundry);
    //console.log("dc_require = ",dc_require);
    this.service_errormsg = ''; 
    if(!is_laundry && !dc_require) {
      this.service_errormsg = errorlist['placeOrder']['is_laundry']; 
    }
  }

  

  checkSaveCard(value){
    if(value == true){
      this.form.controls['expMonth'].markAsUntouched();
      this.form.controls['expMonth'].clearValidators();
      this.form.controls['expMonth'].updateValueAndValidity();
      this.form.patchValue({expMonth : ""}); 
      this.form.controls['expYear'].markAsUntouched();
      this.form.controls['expYear'].clearValidators();
      this.form.controls['expYear'].updateValueAndValidity();
      this.form.patchValue({expYear : ""}); 
      this.form.controls['card_type'].markAsUntouched();
      this.form.controls['card_type'].clearValidators();
      this.form.controls['card_type'].updateValueAndValidity();
      this.form.patchValue({card_type : ""}); 
      this.form.controls['card_number'].markAsUntouched();
      this.form.controls['card_number'].clearValidators();
      this.form.controls['card_number'].updateValueAndValidity();
      this.form.patchValue({card_number : ""}); 
      this.form.controls['csv'].markAsUntouched();
      this.form.controls['csv'].clearValidators();
      this.form.controls['csv'].updateValueAndValidity();
      this.form.patchValue({csv : ""}); 
      this.chooseCardId = this.saveCardData.ORIGPNREF;
    }else{
      this.chooseCardId = "";
      this.form.controls['expMonth'].setValidators([ Validators.required]);
      this.form.controls['expMonth'].updateValueAndValidity();
      this.form.controls['expYear'].setValidators([ Validators.required]);
      this.form.controls['expYear'].updateValueAndValidity();
      this.form.controls['card_type'].setValidators([ Validators.required]);
      this.form.controls['card_type'].updateValueAndValidity();
      this.form.controls['card_number'].setValidators([ Validators.required]);
      this.form.controls['card_number'].updateValueAndValidity();
      this.form.controls['csv'].setValidators([ Validators.required]);
      this.form.controls['csv'].updateValueAndValidity();
    }
  }

  place_oder(){

  }

  onFormSubmit(){
    this.form.controls['day1'].markAsTouched();
    this.form.controls['time1'].markAsTouched();
    this.form.controls['day2'].markAsTouched();
    this.form.controls['time2'].markAsTouched();
    if( this.form.value.orderSecondChoice == true){
      this.form.controls['day3'].markAsTouched();
      this.form.controls['time3'].markAsTouched();
      this.form.controls['day4'].markAsTouched();
      this.form.controls['time4'].markAsTouched();
    }
    
      this.form.controls['expMonth'].markAsTouched();
      this.form.controls['expYear'].markAsTouched();
      this.form.controls['card_type'].markAsTouched();
      this.form.controls['card_number'].markAsTouched();
      this.form.controls['csv'].markAsTouched();
    
    this.form.controls['message'].markAsTouched();
    this.form.controls['whitener'].markAsTouched();
    this.form.controls['softner'].markAsTouched();
    this.form.controls['detergent'].markAsTouched();
    this.form.controls['pay_type'].markAsTouched();
    
    console.log('Form validation',this.form);
    if(this.form.valid) {
      ///console.log(this.form);return false;
      if(this.orderValidation(this.form)){
        this.spinnerService.show();
        
        
      this.orderData = this.form.value;
      //console.log(this.orderData);
      /* Any API call logic via services goes here */
        
      let sid = localStorage.getItem('sid');
      let area = JSON.parse(localStorage.getItem('currentUser'));
      //console.log("area",area)
      let order = {"sid":sid, "first_pickup_day":this.orderData.day1, "first_pickup_time":this.getTimeValue(this.orderData.time1), "first_delivery_day":this.orderData.day2, "first_delivery_time":this.getTimeValue(this.orderData.time2), "second_pickup_day":this.orderData.day3==null?"":this.orderData.day3, "second_pickup_time":this.getTimeValue(this.orderData.time3), "second_delivery_day":this.orderData.day4==null?"":this.orderData.day4, "second_delivery_time":this.getTimeValue(this.orderData.time4),"message":this.orderData.message, "detergent_id":this.orderData.detergent, "softener_id":this.orderData.softner, "whitener_id":this.orderData.whitener, "pay_type":this.orderData.pay_type, "card_id":"", "cardData":"", "recuring":this.orderData.recurring, "dc_require":this.orderData.dc_require, "is_laundry":this.orderData.is_laundry, "rush_order": this.orderData.rush_order}
      console.log("order",order);
      
          let access_token = '';
          
           if(this.orderData.pay_type == "online" && (this.orderData.save_card_id == false || this.orderData.save_card_id == null )){ 
            
                let self = this;
                let addBooking = self.paypal_vault(  function(err, cardResult){
                  if(err){
                    self.spinnerService.hide();
                    self.auth.open(cardResult.replyMsg);
                  }else{
                    //this.spinnerService.hide();
                    if(cardResult.data.RESULT == '0'){
                      order.card_id = cardResult.data.PNREF;
                      order.cardData = cardResult.data;
                      let Booking = self.bookingOrder(order,self, function(err, bookResult){
                        if(err){
                          self.spinnerService.hide();
                          self.auth.open(bookResult.replyMsg);
                        }else{
                          console.log("bookResult", bookResult.replyMsg)
                          self.spinnerService.hide();
                          self.router.navigate(['/my-order']);
                        }
                      });
                    }else{
                      self.spinnerService.hide();
                      self.auth.open(cardResult.data.RESPMSG);
                    }
                  }
                });
               
            
            
           }else{
            console.log(this.orderData)
            order.card_id = this.chooseCardId
            let self = this;
            let Booking = self.bookingOrder(order,self, function(err, bookResult){
              if(err){
                self.spinnerService.hide();
                self.auth.open(bookResult.replyMsg);
              }else{
                console.log("bookResult", bookResult.replyMsg)
                self.spinnerService.hide();
                self.router.navigate(['/my-order']);
              }
            });
          } 
          
      }else{
        console.log("form second choice not validated")
      }
    }else{
      console.log("FORM NOT VALID", this.form.errors);
    }
  }

  paypal_vault(  callback){
    let sid = localStorage.getItem('sid');
    let index = 0;
    let charcount = 2;
    let expYear = (this.orderData.expYear).substr(0, index) +  (this.orderData.expYear).substr(index + charcount);

    let cardData = {
      "ACCT": this.orderData.card_number,
      "EXPDATE": this.orderData.expMonth+expYear,
      "CVV2": this.orderData.csv,
      "sid":sid
    }
  /*   this.auth.card_save1(cardData).subscribe(success => {
      console.log("hdhdhdh", success)
      callback(false, success);
    }, error => {
      callback(true, error);
      console.log("hdhdhdhdddsssss", error)
    }); */
    this.auth.card_save(cardData).then((save) => {
      console.log("dddd",save);
      let response = save.json();
      if(response.replyCode == "error"){
        callback(true, response);
      }else{
        callback(false, response);
      }
    })
    .catch((err) => {
      console.log(err);
      this.auth.open(err)
    });
  }

  bookingOrder(data, self1, callback){
    let self = self1;
    self.auth.add_booking(data).then((user) => {
      console.log("dddd",user);
      let response = user.json();
      if(response.replyCode == "error"){
        callback(true, response);
      }else{
        callback(false, response);
      }
    })
    .catch((err) => {
      console.log(err);
      self.auth.open(environment.error)
    });
  }

  DropdownChange(ev, day, time){
    if(ev == null) return;
    let correctId = 0;
    console.log("ev",ev)
   
    console.log(this.form.valid)
    let TIME_RANGE = this.TIME_RANGE1.length;
   
   // console.log(selectBal);
    let Data = this.orderLimitData[ev];
    for(let i = 0; i < TIME_RANGE ; i++ ){
      correctId = environment.TIME_RANGE_ID_CONVERT[this.TIME_RANGE1[i].id ];
     
      console.log("time",time)
      console.log("Data",Data)
      if( this.TIME_RANGE1[i].id != '0' && this.TIME_RANGE1[i].id != '5' ){

        if( time == 'time1'){
          if( Data[correctId].orderlimit_pickup == 0 ){
            this.TIME_RANGE1[i].disabled = true;
          }else{
            this.TIME_RANGE1[i].disabled = false; 
          }
        } else if( time == 'time2'){
          if( Data[correctId].orderlimit_del == 0 ){
            this.TIME_RANGE2[i].disabled = true;
          }else{
            this.TIME_RANGE2[i].disabled = false; 
          }
        } else if( time == 'time3'){
          if( Data[correctId].orderlimit_pickup == 0 ){
            this.TIME_RANGE3[i].disabled = true;
          }else{
            this.TIME_RANGE3[i].disabled = false; 
          }
        }else if( time == 'time4'){
          if( Data[correctId].orderlimit_del == 0 ){
            this.TIME_RANGE4[i].disabled = true;
          }else{
            this.TIME_RANGE4[i].disabled = false; 
          }
        }
      }

    }
    console.log("this.TIME_RANGE1",this.TIME_RANGE1)
    console.log("this.TIME_RANGE2",this.TIME_RANGE2)
    console.log("this.TIME_RANGE3",this.TIME_RANGE3)
    console.log("this.TIME_RANGE4",this.TIME_RANGE4)


    if( time == 'time1'){
      this.form.patchValue({time1 : null}); //puDay1
    }else if( time == 'time2' ){
      this.form.patchValue({time2 : null}); 
    }else if( time == 'time3' ){
      this.form.patchValue({time3 : null}); 
    }else if( time == 'time4' ){
      this.form.patchValue({time4 : null}); 
    }
  }

  orderValidation(form){
  //console.log(form.value);

    let is_laundry = form.value.is_laundry;
    let dc_require = form.value.dc_require;
    //console.log("is_laundry = ",is_laundry);
    //console.log("dc_require = ",dc_require);
    if(!is_laundry && !dc_require) {
      this.service_errormsg = errorlist['placeOrder']['is_laundry']; 
      return false;
    }

    //return false;
    if((((form.value.day3 == null || form.value.day3 == '') || (form.value.day4 == null || form.value.day4 == '' ) || (form.value.time3 == null || form.value.time3 == '') || (form.value.time4 == null || form.value.time4 == '')) && (form.value.orderSecondChoice == true))){
      console.log("enter in second choice error")
      return false;
    }
    if((((form.value.expMonth == null || form.value.expMonth == '') || (form.value.expYear == null || form.value.expYear == '' ) || (form.value.card_number == null || form.value.card_number == '') || (form.value.card_type == null || form.value.card_type == '') || (form.value.csv == null || form.value.csv == '')) && (form.value.pay_type == 'online') && (form.value.save_card_id == false))){
      console.log("Paypal error")
      return false;
    }
    var puDay = [];
    var puTime = [];
    var dvDay = [];
    var dvTime = [];

    puDay[1] = form.value.day1;
    puDay[2] = form.value.day3;
    
    //puTime[1] = form.value.time1;
    //puTime[2] = form.value.time3;
    puTime[1] = this.getTimeValue(form.value.time1);
    puTime[2] = this.getTimeValue(form.value.time3);
    
    dvDay[1] = form.value.day2;
    dvDay[2] = form.value.day4;
    
    //dvTime[1] = form.value.time2;
    //dvTime[2] = form.value.time4;
    dvTime[1] = this.getTimeValue(form.value.time2);
    dvTime[2] = this.getTimeValue(form.value.time4);

    console.log(puDay);
    console.log(dvDay);
    var j = 1;
    var i = 0;
    for (j = 1;j < 3;j++){
      for (i = 0;i < 6;i++){
        if (((puDay[j] == i) && (puTime[j] > 18)) && ((dvDay[j] == i+1) && (dvTime[j] < 19))) {
          this.errormsg = 'Orders cannot be picked up at night and delivered next morning.'; 
          return false;
        }
      }
      if (((puDay[j] == 6) && (puTime[j] > 18)) && ((dvDay[j] == 1) && (dvTime[j] < 19))) {
        this.errormsg='Orders cannot be picked up at night and delivered next morning.'; 
        return false;
      }
    }
    for (j = 1;j < 3;j++){
      //console.log(((puDay[j] == 5) +''+ (puTime[j] > 18)) +''+ ((dvDay[j] == 0)));
      //console.log(dvDay[j])
        if (((puDay[j] == 5) && (puTime[j] > 18)) && ((dvDay[j] == 0))) {
          this.errormsg='Orders cannot be picked up Friday night and delivered Sunday.'; 
          return false;
        }
        if (((puDay[j] == 5) && (puTime[j] > 18)) && ((dvDay[j] == 1) && (dvTime[j] < 19))) {
          this.errormsg ='Orders cannot be picked up Friday night and delivered Monday morning.'; 
          return false;
        }
        if (((puDay[j] == 6) && (puTime[j] < 19)) || ((dvDay[j] == 6) && (dvTime[j] < 19))) {
          this.errormsg='Orders cannot be picked up or delivered Sunday mornings.'; 
          return false;
        }
        for (i = 0;i < 6;i++){
          if (((puDay[j] == i && puDay[j]!='') && (puTime[j] < 18)) && ((dvDay[j] == i) && (dvTime[j] < 18))) {
            //console.log('i value = '+i);
            //console.log('puDay = '+puDay[j]);
            //console.log('dvDay = '+dvDay[j]);
            this.errormsg='Orders cannot be picked up and delivered the same morning or same evening.'; 
            return false;
          }
          if (((puDay[j] == i && puDay[j]!='') && (puTime[j] > 18)) && ((dvDay[j] == i) && (dvTime[j] > 18))) {
            this.errormsg='Orders cannot be picked up and delivered the same morning or same evening.'; 
            return false;
          }
        }

      }

      if ((puDay[1] + ', ' + puTime[1]) == (puDay[2] + ', ' + puTime[2])) {
          this.errormsg='1st and 2nd Choice Pick-up options cannot be the same.'; 
          return false;
      }
      if(form.value.orderSecondChoice){;
        if ((dvDay[1] + ', ' + dvTime[1]) == (dvDay[2] + ', ' + dvTime[2])) {
          this.errormsg='1st and 2nd Choice Delivery options cannot be the same.'; 
          return false;
        }
      }

      //Logic for in case dry cleaning service choosed by user
      if(dc_require) {
        for (j = 1;j < 3;j++){
          for (i = 0;i < 6;i++){

            if (i==4 || i==5) {
              let d = i-4;
              if (((puDay[j] == i && puDay[j]!='') && (puTime[j] < 18)) && ((dvDay[j] < d)  /* || (dvDay[j] == d && dvTime[j] < 18) */) ) {
                console.log('i value = '+i);
                console.log('puDay = '+puDay[j]);
                console.log('dvDay = '+dvDay[j]);
                console.log('d = '+d);
                this.errormsg='Orders cannot be picked up and delivered before 48 hours in case if you choose dry cleaning service.'; 
                return false;
              }

              if (((puDay[j] == i && puDay[j]!='') && (puTime[j] > 18)) && ((dvDay[j] < d ) || (dvDay[j] == d && dvTime[j] < 18)  )) {
                this.errormsg='Orders cannot be picked up and delivered before 48 hours in case if you choose dry cleaning service.'; 
                return false;
              }
            } else {
              if (((puDay[j] == i && puDay[j]!='') && (puTime[j] < 18)) && ((dvDay[j] < (i+2)) /* || (dvDay[j] == (i+2) && dvTime[j] < 18) */) ) {
                this.errormsg='Orders cannot be picked up and delivered before 48 hours in case if you choose dry cleaning service.'; 
                return false;
              }
              if (((puDay[j] == i && puDay[j]!='') && (puTime[j] > 18)) && ((dvDay[j] < (i+2) || (dvDay[j] == (i+2) && dvTime[j] < 18) ) )) {
                this.errormsg='Orders cannot be picked up and delivered before 48 hours in case if you choose dry cleaning service.'; 
                return false;
              }
            }
 

          }

        }
        
      }


      this.errormsg= "";
      return true;
  }

  getTimeValue(index){
    return ( this.TIME_RANGE_ID_CONVERT[index] ? this.TIME_RANGE_ID_CONVERT[index] : index );
    //return ( this.TIME_RANGE_ID_CONVERT[index] ? this.TIME_RANGE_ID_CONVERT[index] : '' );
  }

  test(dd){
    console.log(JSON.stringify(dd));
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/place-holder/place-holder.component.ts